import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { InitiationItemDetailForEditorFragmentDoc } from './initiation-item-fragment.generated';
import { ContactFragmentOnContactFeedFragmentDoc } from '../../../crm/contacts/__generated__/contact-fragment.generated';
import { StepImageUploadOnFeedFragmentDoc } from '../../../media/step-image-uploads/__generated__/step-image-upload.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitiationItemOnStoryEditorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type InitiationItemOnStoryEditorQuery = { __typename?: 'RootQueryType', initiationItem?: { __typename?: 'InitiationItem', id: string, databaseId: any, title: string, headline?: string | null, type: Types.InitiationItemType, interactionType: Types.InteractionType, order: number, collectContact: boolean, useTextFallback: boolean, textColor?: string | null, blurEffect?: number | null, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle?: number | null, useTeleprompter: boolean, teleprompterScript?: string | null, teleprompterSpeed?: number | null, teleprompterFontSize?: number | null, teleprompterFontColor?: string | null, showContact: boolean, showContactName: boolean, showContactAvatar: boolean, showContactJobTitle: boolean, showCompanySymbol: boolean, showCompanyName: boolean, interactions: Array<{ __typename: 'HotspotInteraction', id: string, type: Types.InteractionType, hotspotInteractionId: string, hotspots: Array<{ __typename?: 'Hotspot', id: string, x: number, y: number, text: string, textColor: string, bgColor: string, alwaysShowText: boolean, destinationType?: Types.NextInteractionType | null, value?: string | null, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null } }> } | { __typename: 'MultipleChoiceInteraction', id: string, type: Types.InteractionType, multipleChoiceInteractionId: string, question: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } } | { __typename: 'ShoppableInteraction', id: string, type: Types.InteractionType, count: number, shoppableInteractionId: string, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> }>, question?: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } | null, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, name?: string | null, rawUrl?: string | null, alternativeText?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, thumbUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, duration?: number | null, size?: number | null, insertedAt?: any | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null, chapters?: Array<{ __typename?: 'NarrationChapter', id: string, title?: string | null, slidePageNumber?: number | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null }> | null } | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null } | null, formFields?: Array<{ __typename?: 'AudioField' } | { __typename?: 'EmailField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'LongTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'PhoneField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'ShortTextField', id: string, key?: string | null, label: string, isRequired: boolean, isHidden: boolean } | { __typename?: 'VideoField' } | null> | null } | null, colors?: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> | null } | null };

export type InitiationItemForFileUploadQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type InitiationItemForFileUploadQuery = { __typename?: 'RootQueryType', initiationItem?: { __typename?: 'InitiationItem', id: string, databaseId: any, title: string, type: Types.InitiationItemType, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, file?: { __typename?: 'FileUpload', id: string, name?: string | null, size?: number | null, pageCount?: number | null, mimeType?: string | null, fileUrl?: string | null } | null } | null } | null };

export type InitiationItemForEmbedQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type InitiationItemForEmbedQuery = { __typename?: 'RootQueryType', initiationItem?: { __typename?: 'InitiationItem', id: string, databaseId: any, title: string, type: Types.InitiationItemType, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, providerName?: string | null, oembedResult?: any | null } | null } | null };

export type InitiationItemOnStoryPlayerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type InitiationItemOnStoryPlayerQuery = { __typename?: 'RootQueryType', initiationItem?: { __typename?: 'InitiationItem', id: string, databaseId: any, title: string, type: Types.InitiationItemType, order: number, question?: { __typename?: 'PageQuestion', id: string, title?: string | null, titleColor: string, showTitle: boolean, timing: number, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null }> } | null, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null } | null, chapters?: Array<{ __typename?: 'NarrationChapter', id: string, title?: string | null, slidePageNumber?: number | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null } | null }> | null } | null, file?: { __typename?: 'FileUpload', id: string, fileUrl?: string | null, name?: string | null, size?: number | null, pageCount?: number | null } | null } | null } | null };


export const InitiationItemOnStoryEditorDocument = gql`
    query initiationItemOnStoryEditor($id: ID!) {
  initiationItem(id: $id) {
    ...InitiationItemDetailForEditor
  }
}
    ${InitiationItemDetailForEditorFragmentDoc}`;

/**
 * __useInitiationItemOnStoryEditorQuery__
 *
 * To run a query within a React component, call `useInitiationItemOnStoryEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemOnStoryEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemOnStoryEditorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationItemOnStoryEditorQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemOnStoryEditorQuery, InitiationItemOnStoryEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemOnStoryEditorQuery, InitiationItemOnStoryEditorQueryVariables>(InitiationItemOnStoryEditorDocument, options);
      }
export function useInitiationItemOnStoryEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemOnStoryEditorQuery, InitiationItemOnStoryEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemOnStoryEditorQuery, InitiationItemOnStoryEditorQueryVariables>(InitiationItemOnStoryEditorDocument, options);
        }
export type InitiationItemOnStoryEditorQueryHookResult = ReturnType<typeof useInitiationItemOnStoryEditorQuery>;
export type InitiationItemOnStoryEditorLazyQueryHookResult = ReturnType<typeof useInitiationItemOnStoryEditorLazyQuery>;
export type InitiationItemOnStoryEditorQueryResult = Apollo.QueryResult<InitiationItemOnStoryEditorQuery, InitiationItemOnStoryEditorQueryVariables>;
export function refetchInitiationItemOnStoryEditorQuery(variables: InitiationItemOnStoryEditorQueryVariables) {
      return { query: InitiationItemOnStoryEditorDocument, variables: variables }
    }
export const InitiationItemForFileUploadDocument = gql`
    query initiationItemForFileUpload($id: ID!) {
  initiationItem(id: $id) {
    id
    databaseId
    title
    type
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      file {
        id
        name
        size
        pageCount
        mimeType
        fileUrl
      }
    }
  }
}
    `;

/**
 * __useInitiationItemForFileUploadQuery__
 *
 * To run a query within a React component, call `useInitiationItemForFileUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemForFileUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemForFileUploadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationItemForFileUploadQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemForFileUploadQuery, InitiationItemForFileUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemForFileUploadQuery, InitiationItemForFileUploadQueryVariables>(InitiationItemForFileUploadDocument, options);
      }
export function useInitiationItemForFileUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemForFileUploadQuery, InitiationItemForFileUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemForFileUploadQuery, InitiationItemForFileUploadQueryVariables>(InitiationItemForFileUploadDocument, options);
        }
export type InitiationItemForFileUploadQueryHookResult = ReturnType<typeof useInitiationItemForFileUploadQuery>;
export type InitiationItemForFileUploadLazyQueryHookResult = ReturnType<typeof useInitiationItemForFileUploadLazyQuery>;
export type InitiationItemForFileUploadQueryResult = Apollo.QueryResult<InitiationItemForFileUploadQuery, InitiationItemForFileUploadQueryVariables>;
export function refetchInitiationItemForFileUploadQuery(variables: InitiationItemForFileUploadQueryVariables) {
      return { query: InitiationItemForFileUploadDocument, variables: variables }
    }
export const InitiationItemForEmbedDocument = gql`
    query initiationItemForEmbed($id: ID!) {
  initiationItem(id: $id) {
    id
    databaseId
    title
    type
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      providerName
      oembedResult
    }
  }
}
    `;

/**
 * __useInitiationItemForEmbedQuery__
 *
 * To run a query within a React component, call `useInitiationItemForEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemForEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemForEmbedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationItemForEmbedQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemForEmbedQuery, InitiationItemForEmbedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemForEmbedQuery, InitiationItemForEmbedQueryVariables>(InitiationItemForEmbedDocument, options);
      }
export function useInitiationItemForEmbedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemForEmbedQuery, InitiationItemForEmbedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemForEmbedQuery, InitiationItemForEmbedQueryVariables>(InitiationItemForEmbedDocument, options);
        }
export type InitiationItemForEmbedQueryHookResult = ReturnType<typeof useInitiationItemForEmbedQuery>;
export type InitiationItemForEmbedLazyQueryHookResult = ReturnType<typeof useInitiationItemForEmbedLazyQuery>;
export type InitiationItemForEmbedQueryResult = Apollo.QueryResult<InitiationItemForEmbedQuery, InitiationItemForEmbedQueryVariables>;
export function refetchInitiationItemForEmbedQuery(variables: InitiationItemForEmbedQueryVariables) {
      return { query: InitiationItemForEmbedDocument, variables: variables }
    }
export const InitiationItemOnStoryPlayerDocument = gql`
    query initiationItemOnStoryPlayer($id: ID!) {
  initiationItem(id: $id) {
    id
    databaseId
    title
    type
    order
    question {
      id
      title
      titleColor
      showTitle
      timing
      choices {
        id
        type
        hasNext
        text
        value
        order
        middleInteraction {
          id
          type
          question
          embed {
            id
            linkUrl
            oembedResult
            status
            reason
          }
        }
        nextPage {
          id
          title
          type
          order
        }
      }
    }
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      oembedResult
      providerName
      videoContain
      video {
        id
        rawUrl
        transcodedUrl
        previewUrl
        streamUrl
        contact {
          ...ContactFragmentOnContactFeed
        }
      }
      image {
        ...StepImageUploadOnFeed
      }
      narration {
        id
        title
        type
        video {
          id
          rawUrl
          transcodedUrl
          previewUrl
          streamUrl
        }
        chapters {
          id
          title
          slidePageNumber
          video {
            id
            rawUrl
            transcodedUrl
            previewUrl
            streamUrl
          }
        }
      }
      file {
        id
        fileUrl
        name
        size
        pageCount
      }
    }
  }
}
    ${ContactFragmentOnContactFeedFragmentDoc}
${StepImageUploadOnFeedFragmentDoc}`;

/**
 * __useInitiationItemOnStoryPlayerQuery__
 *
 * To run a query within a React component, call `useInitiationItemOnStoryPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiationItemOnStoryPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiationItemOnStoryPlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiationItemOnStoryPlayerQuery(baseOptions: Apollo.QueryHookOptions<InitiationItemOnStoryPlayerQuery, InitiationItemOnStoryPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitiationItemOnStoryPlayerQuery, InitiationItemOnStoryPlayerQueryVariables>(InitiationItemOnStoryPlayerDocument, options);
      }
export function useInitiationItemOnStoryPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitiationItemOnStoryPlayerQuery, InitiationItemOnStoryPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitiationItemOnStoryPlayerQuery, InitiationItemOnStoryPlayerQueryVariables>(InitiationItemOnStoryPlayerDocument, options);
        }
export type InitiationItemOnStoryPlayerQueryHookResult = ReturnType<typeof useInitiationItemOnStoryPlayerQuery>;
export type InitiationItemOnStoryPlayerLazyQueryHookResult = ReturnType<typeof useInitiationItemOnStoryPlayerLazyQuery>;
export type InitiationItemOnStoryPlayerQueryResult = Apollo.QueryResult<InitiationItemOnStoryPlayerQuery, InitiationItemOnStoryPlayerQueryVariables>;
export function refetchInitiationItemOnStoryPlayerQuery(variables: InitiationItemOnStoryPlayerQueryVariables) {
      return { query: InitiationItemOnStoryPlayerDocument, variables: variables }
    }